//系统内置指标样式6：教师行为表情情况分析
<template>
  <div class="indicator-container">
    <ListHeader title="教师行为表情情况分析"/>
    <div class="indicator-content">
      <div class="score-box">
        <Score :score="data.score" :max-score="data.maxScore"/>
      </div>
      <div class="divider"></div>
      <div class="text-box">

        {{ data.remark }}
        <!-- 教师在整节课中始终围绕“名字里的故事
        ”这一核心教学内容，结合教材意图和课
        后练习要求，设定了清晰、具体、可操作
        的教学目标。例如，在导入阶段
        (00:26-05:12)，教师通过引导学生猜测
        自己的名字由来，激发学生的表达动机，
        并自然过渡到学习如何讲述自己... -->
      </div>
      <div class="divider"></div>
      <div class="chart-box">
        <div class="evidence-box">
          <div id="bar-chart" class="bar-chart"></div>
        </div>

        <div id="pie-chart1" class="pie-chart1"></div>
        <div id="pie-chart2" class="pie-chart2"></div>
      </div>
    </div>
  </div>
</template>
<script>

import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';

export default {
  name: 'SysTeacherEmoji',
  components: {
    ListHeader,
    Score,
  },

  props: {
    data: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      pieChart1: null,
      pieChart2: null,
      barChart: null
    };
  },
  computed: {
    parsedExtra() {
      try {
        return JSON.parse(this.data?.extra || '{}').behavior_emotion_analysis || {};
      } catch (e) {
        console.warn('解析extra数据失败:', e);
        return {};
      }
    }
  },
  mounted() {
    // 确保DOM完全渲染后再初始化图表
    this.$nextTick(() => {
      this.initBarChart();
      this.initPieChart1();
      this.initPieChart2();
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.barChart) {
      this.barChart.dispose();
      this.barChart = null;
    }
    if (this.pieChart1) {
      this.pieChart1.dispose();
      this.pieChart1 = null;
    }
    if (this.pieChart2) {
      this.pieChart2.dispose();
      this.pieChart2 = null;
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initBarChart() {
      // 获取图表容器
      const chartContainer = document.getElementById('bar-chart');
      if (chartContainer) {
        // 设置图表容器高度和宽度
        chartContainer.style.width = '100%';
        chartContainer.style.height = '100%';
        // 初始化图表
        this.barChart = echarts.init(chartContainer);
        // 渲染图表
        this.renderBarChart();
      } else {
        console.error('Bar Chart container not found');
      }
    },
    //处理聚合数据
    aggregateTimeline(data, minutes = 5) {

      const timeline = data.visual_analysis_timeline
      const bucket = minutes * 60

      const map = {}

      timeline.forEach(item => {

        const [m, s] = item.timestamp.split(":").map(Number)
        const sec = m * 60 + s
        const index = Math.floor(sec / bucket)

        if (!map[index]) {
          map[index] = {action: {}, emotion: {}}
        }

        map[index].action[item.action_code] =
            (map[index].action[item.action_code] || 0) + 1

        map[index].emotion[item.emotion_code] =
            (map[index].emotion[item.emotion_code] || 0) + 1
      })

      const result = []

      Object.entries(map).forEach(([i, b]) => {

        const action = Object.entries(b.action)
            .sort((a, b) => b[1] - a[1])[0]

        const emotion = Object.entries(b.emotion)
            .sort((a, b) => b[1] - a[1])[0]

        result.push({
          slot: Number(i),
          action: action[0],
          emotion: emotion[0]
        })
      })

      return result
    },
    buildSegments(agg, minutes) {

      const segmentsAction = []
      const segmentsEmotion = []

      agg.forEach((r, i) => {

        const start = i * minutes
        const end = (i + 1) * minutes

        segmentsAction.push({
          name: r.action,
          value: [start, end]
        })

        segmentsEmotion.push({
          name: r.emotion,
          value: [start, end]
        })

      })

      return {segmentsAction, segmentsEmotion}
    },
    formatMinutes(min) {

      return min

      // const h = Math.floor(min / 60)
      // const m = Math.floor(min % 60)
      //
      // const hh = String(h).padStart(2, "0")
      // const mm = String(m).padStart(2, "0")
      //
      // return `${hh}:${mm}`
    },
    renderBarChart() {
      const minutes = 5;
      const agg = this.aggregateTimeline(this.parsedExtra, minutes);
      const defs = this.parsedExtra.definitions;

      if (!agg || !defs) {
        return;
      }

      const actionData = agg.map(item => ({
        name: defs.action_codes[item.action] || '未知',
        value: [
          item.slot * minutes, // start time
          (item.slot + 1) * minutes, // end time
          0, // y-axis index for '主要行为'
        ],
        itemStyle: {
          color: this.getColor(defs.action_codes[item.action] || '未知')
        }
      }));

      const emotionData = agg.map(item => ({
        name: defs.emotion_codes[item.emotion] || '未知',
        value: [
          item.slot * minutes, // start time
          (item.slot + 1) * minutes, // end time
          1, // y-axis index for '主要表情'
        ],
        itemStyle: {
          color: this.getColor(defs.emotion_codes[item.emotion] || '未知')
        }
      }));

      const renderItem = (params, api) => {
        const categoryIndex = api.value(2);
        const start = api.coord([api.value(0), categoryIndex]);
        const end = api.coord([api.value(1), categoryIndex]);
        const height = api.size([0, 1])[1] * 0.3;

        const rectShape = echarts.graphic.clipRectByRect({
          x: start[0],
          y: start[1] - height / 2,
          width: end[0] - start[0],
          height: height
        }, {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height
        });

        return rectShape && {
          type: 'rect',
          shape: rectShape,
          style: api.style()
        };
      };

      const option = {
        tooltip: {
          formatter: (params) => {
            const startTime = params.value[0];
            const endTime = params.value[1];
            return `${params.marker} ${startTime}-${endTime}min: ${params.name}`;
          }
        },
        grid: { left: 100, right: 40, top: 20, bottom: 40 },
        xAxis: {
          type: 'value',
          name: '时间(min)',
          nameLocation: 'center',
          nameGap: 25,
          axisLine: { show: true, lineStyle: { color: "#ccc" } },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { color: "#999" }
        },
        yAxis: {
          type: 'category',
          data: ["主要行为", "主要表情"],
          axisLine: { show: true, lineStyle: { color: "#999", width: 1 } },
          axisTick: { show: false },
          axisLabel: { fontSize: 14, fontWeight: 600 }
        },
        series: [
          {
            name: '主要行为',
            type: 'custom',
            renderItem: renderItem,
            itemStyle: { opacity: 0.8 },
            encode: { x: [0, 1], y: 2 },
            data: actionData
          },
          {
            name: '主要表情',
            type: 'custom',
            renderItem: renderItem,
            itemStyle: { opacity: 0.8 },
            encode: { x: [0, 1], y: 2 },
            data: emotionData
          }
        ]
      };

      this.barChart.setOption(option);
    },
    getColor(name) {
      // Simple hash function to get a color from a string
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
      return "#" + "00000".substring(0, 6 - c.length) + c;
    },
    initPieChart1() {
      // 获取图表容器
      const chartContainer = document.getElementById('pie-chart1');
      if (chartContainer) {
        // 设置图表容器高度和宽度
        chartContainer.style.width = '100%';
        chartContainer.style.height = '100%';
        // 初始化图表
        this.pieChart1 = echarts.init(chartContainer);
        // 渲染图表
        this.renderPieChart1();
      } else {
        console.error('Pie Chart 1 container not found');
      }
    },
    initPieChart2() {
      // 获取图表容器
      const chartContainer = document.getElementById('pie-chart2');
      if (chartContainer) {
        // 设置图表容器高度和宽度
        chartContainer.style.width = '100%';
        chartContainer.style.height = '100%';
        // 初始化图表
        this.pieChart2 = echarts.init(chartContainer);
        // 渲染图表
        this.renderPieChart2();
      } else {
        console.error('Pie Chart 2 container not found');
      }
    },

    renderPieChart1() {
      const extra = this.parsedExtra

      const mockData = Object.entries(extra.action_statistics?.counts || {}).map(([key, value]) => {
        return {
          value: value,
          name: extra.definitions?.action_codes?.[key] || '未知'
        };
      });
      // Mock数据 - 饼图1数据
      // const mockData = [
      //     { value: 35, name: '鼓掌' },
      //     { value: 25, name: '讲授' },
      //     { value: 15, name: '使用手机' },
      //     { value: 5, name: '操作电脑' },
      //     { value: 20, name: '板书' },
      // ];

      // 图表配置 - 左边饼图，右边图例
      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 28, 53, 0.8)',
          borderColor: '#0585F7',
          borderWidth: 1,
          textStyle: {
            color: '#FFF'
          },
          formatter: '{b}: {c}% ({d}%)'
        },

        legend: {
          orient: 'vertical',
          right: '10%',
          top: 'center',
          width: 100, // 设置固定宽度
          textStyle: {
            color: '#FFF',
            fontSize: 12,
            overflow: 'truncate', // 文本超出时截断
            width: 100 // 文本显示宽度
          },
          formatter: function (name) {
            // 查找对应名称的数据项
            var data = mockData;
            var total = 0;
            var value = 0;
            for (var i = 0; i < data.length; i++) {
              total += data[i].value;
              if (data[i].name === name) {
                value = data[i].value;
              }
            }
            // 计算百分比并格式化
            var percent = ((value / total) * 100).toFixed(1) + '%';
            return name + ' ' + percent;
          }
        },
        series: [
          {
            name: '行为分布',
            type: 'pie',
            radius: ['55%', '60%'], // 将圆环调细，内圆60%，外圆75%
            center: ['35%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: 'rgba(0, 28, 53, 0.7)',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
                color: '#FFF'
              }
            },
            labelLine: {
              show: false
            },
            data: mockData,
            // 在圆环中心显示默认信息
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter: '',
                fontSize: 14,
                color: '#FFF',
                fontWeight: 'bold'
              },
              emphasis: {
                show: true,
                formatter: '{b|{b}}\n\n{percent|{d}%}',
                fontSize: 16,
                color: '#FFF',
                fontWeight: 'bold',
                rich: {
                  b: {
                    fontSize: 16,
                    color: '#FFF',
                    fontWeight: 'bold'
                  },
                  percent: {
                    fontSize: 24, // 将百分比字体放大
                    color: '#FFF',
                    fontWeight: 'bold'
                  }
                }
              }
            }
          }
        ]
      };

      this.pieChart1.setOption(option);
    },
    renderPieChart2() {
      // Mock数据 - 饼图2数据

      const extra = this.parsedExtra

      const mockData = Object.entries(extra.emotion_statistics?.counts || {}).map(([key, value]) => {
        return {
          value: value,
          name: extra.definitions?.emotion_codes?.[key] || '未知'
        };
      });
      // const mockData = [
      //     { value: 40, name: '生气' },
      //     { value: 10, name: '厌恶' },
      //     { value: 10, name: '恐惧' },
      //     { value: 10, name: '高兴' },
      //     { value: 10, name: '悲伤' },
      //     { value: 10, name: '惊讶' },
      //     { value: 10, name: '中性' },
      // ];

      // 图表配置 - 左边饼图，右边图例
      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 28, 53, 0.8)',
          borderColor: '#0585F7',
          borderWidth: 1,
          textStyle: {
            color: '#FFF'
          },
          formatter: '{b}: {c}% ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: '10%',
          top: 'center',
          width: 100, // 设置固定宽度
          textStyle: {
            color: '#FFF',
            fontSize: 12,
            overflow: 'truncate', // 文本超出时截断
            width: 100 // 文本显示宽度
          },
          formatter: function (name) {
            // 查找对应名称的数据项
            var data = mockData;
            var total = 0;
            var value = 0;
            for (var i = 0; i < data.length; i++) {
              total += data[i].value;
              if (data[i].name === name) {
                value = data[i].value;
              }
            }
            // 计算百分比并格式化
            var percent = ((value / total) * 100).toFixed(1) + '%';
            return name + ' ' + percent;
          }
        },
        series: [
          {
            name: '情绪分布',
            type: 'pie',
            radius: ['55%', '60%'], // 将圆环调细，内圆60%，外圆75%
            center: ['35%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: 'rgba(0, 28, 53, 0.7)',
              borderWidth: 2
            },
            labelLine: {
              show: false
            },
            data: mockData,
            // 在圆环中心显示默认信息
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter: '',
                fontSize: 14,
                color: '#FFF',
                fontWeight: 'bold'
              },
              emphasis: {
                show: true,
                formatter: '{b|{b}}\n\n{percent|{d}%}',
                fontSize: 16,
                color: '#FFF',
                fontWeight: 'bold',
                rich: {
                  b: {
                    fontSize: 16,
                    color: '#FFF',
                    fontWeight: 'bold'
                  },
                  percent: {
                    fontSize: 24, // 将百分比字体放大
                    color: '#FFF',
                    fontWeight: 'bold'
                  }
                }
              }
            }
          }
        ]
      };

      this.pieChart2.setOption(option);
    },
    handleResize() {
      if (this.barChart) {
        this.barChart.resize();
      }
      if (this.pieChart1) {
        this.pieChart1.resize();
      }
      if (this.pieChart2) {
        this.pieChart2.resize();
      }
    }
  }
}
</script>
<style scoped lang="less">
// 引入通用指标样式
@import '@/assets/css/common-indicator.less';

.indicator-container {
  height: 356px;

  .indicator-content {

    .text-box {
      width: 400px;
    }

    .chart-box {
      display: flex;
      flex-direction: row;

      .evidence-box {
        flex: 1;
      }

      .pie-chart1 {
        flex: 1;
      }

      .pie-chart2 {
        flex: 1;
      }
    }
  }
}
</style>
